import { IFilter } from '../../types/advancedFilters';
import { RoomsInDealContainer } from '../../containers/advancedFilters/RoomsInDealContainer';

export const roomsInDeal: IFilter = {
  component: RoomsInDealContainer,
};
